import AccountStatusTimeline from '@/views/accounts/accounts-details/account-status-timeline';
import DispatchersMixin from '@/mixins/dispatchers';

export default {
    name: 'AccountInfoBox',

    props: ['account', 'accountPositions'],

    components: {
        AccountStatusTimeline
    },

    mixins: [DispatchersMixin],

    data() {
        return {
            isLoading: false,
            changeDistributorUrl: null,
        }
    },

    methods: {
        /**
         * @override
         */
        remove(account) {
            this.$accountsService.deleteByUUIId(account.uuid).then(res => {
                this.closeActiveTab('accounts');
                this.$toast.success(`${res.result.http_code}`, `${res.result.info}`);
            });
        },
        generateChangeDistributorUrl() {
            this.isLoading = true;
            try {
                const obPath = localStorage.getItem('OBPATH');

                if (!obPath || !this.account || !this.account.uuid) {
                    this.$toast.error('Error', 'Se produjo un error al generar el enlace de cambio de distribuidor.');
                    return null;
                }

                const base = obPath.replace(/\/+$/, '');
                this.changeDistributorUrl = `${base}?account_uuid=${encodeURIComponent(this.account.uuid)}`;
                this.$bvToast.toast('Copia el enlace para compartirlo.', {
                    title: 'Enlace generado',
                    variant: 'success',
                    solid: true,
                    autoHideDelay: 2000,
                });
                return this.changeDistributorUrl;
            } catch (error) {
                console.error(error);
                this.$toast.error('Error', 'Se produjo un error al generar el enlace de cambio de distribuidor.');
                return null;
            } finally {
                this.isLoading = false
            }
        },
        copyToClipboard() {
            navigator.clipboard.writeText(this.changeDistributorUrl).then(() => {
                this.$bvToast.toast('Enlace copiado al portapapeles', {
                    title: 'Éxito',
                    variant: 'success',
                    solid: true,
                    autoHideDelay: 2000,
                });
            });
        }
    },
    computed: {
        totalPositions() {
            let totalPositions = 0;
            if (this.accountPositions && this.accountPositions.length) {
                this.accountPositions.forEach(position => {
                    totalPositions += position.current_amount;
                });
            }
            return totalPositions;
        },
        defaultDistributor() {
            return this.$store.getters['configVarsStore/getDefaultDistributorUuid'];
        },
        allowMarketerChange() {
            return this.$store.getters['configVarsStore/getAllowMarketerChange'];
        },
        hasExternalCodes() {
            const ec = this.account?.external_code;

            if (Array.isArray(ec)) {
                // Hay al menos un código sin key_fund y no vacío
                return ec.some(item =>
                    item &&
                    !item.key_fund &&
                    item.external_code &&
                    String(item.external_code).trim() !== ''
                );
            }

            if (typeof ec === 'string') {
                return ec.trim().length > 0;
            }

            return false;
        },

        externalCodesText() {
            const ec = this.account?.external_code;

            // 1) Array (system_mappings): solo items sin key_fund
            if (Array.isArray(ec) && ec.length) {
                const codes = [...new Set(
                    ec
                        .filter(item => item && !item.key_fund && item.external_code)
                        .map(item => String(item.external_code).trim())
                )];
                return codes.filter(Boolean).join(' · ');
            }

            // 2) String (accounts.external_code)
            if (typeof ec === 'string') {
                return ec.trim();
            }

            // 3) No hay ninguno
            return '';
        }
    }

};
